<template>
  <router-link v-if="link" :to="link" :class="nameClass">
    <slot />
  </router-link>
  <div v-else-if="!link" v-on:click="acao()" :class="nameClass">
    <slot />
  </div>
</template>
<script>
export default {
  name: "Botao",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    nameClass: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    acao() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.relatorio-card-link {
  @include transition-all();
}
hr {
  color: #e9ecef !important;
  border-color: #e9ecef !important;
  border-width: 2px;
}
</style>
